import Typography from '@ixigo/iui/Typography';
import { CountDownTimer } from './countDown-timer';

export interface PendingWidgetProps {
	infoText: string;
	durationMs: number;
	startTimeEpoch: number;
}

export default function PendingWidget(props: PendingWidgetProps) {
	const { infoText, durationMs = 0, startTimeEpoch = 0 } = props;
	return (
		<div className="flex justify-between items-center bg-warning-subtle rounded-20 p-10 pl-15 gap-x-5">
			<Typography variant="body-xs">{infoText}</Typography>
			<CountDownTimer
				durationMs={durationMs}
				startTimeEpoch={startTimeEpoch}
				onExpire={() => {
					window.location.reload();
				}}
			/>
		</div>
	);
}
